module.exports = __webpack_public_path__ + "static/media/walk-step.ce3a4fa0.svg";